export enum SSO_PLATFORMS {
  google = 'google',
  microsoft = 'microsoft',
  facebook = 'facebook',
}
